import { render } from "./InternalPoolConfirm.vue?vue&type=template&id=2dddf5f2&scoped=true"
import script from "./InternalPoolConfirm.vue?vue&type=script&lang=js"
export * from "./InternalPoolConfirm.vue?vue&type=script&lang=js"

import "./InternalPoolConfirm.vue?vue&type=style&index=0&id=2dddf5f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dddf5f2"]])

export default __exports__